<dialog-draggable-header>Create a Duplicate TPR for a Revision</dialog-draggable-header>

<mat-dialog-content>
    <b>Checking Fixture Number: {{toolNo}}</b>
</mat-dialog-content>

<mat-divider class="mt-4"></mat-divider>

<mat-dialog-actions class="float-right">
    Select Revision Letter
    <mat-form-field class="d-block mx-2">
        <mat-select placeholder="Revision Letter" [formControl]="selectedRev">
            <mat-option *ngFor="let revSource of revOpts" [value]="revSource">
                {{revSource}}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <button mat-raised-button color="primary" [disabled]="!selectedRev.valid || loading" (click)="duplicateTpr()">
        Continue
    </button>
    <button mat-raised-button mat-dialog-close [disabled]="loading">Cancel</button>
</mat-dialog-actions>